import { create } from "zustand";

interface ChangelogState {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useChangelogStore = create<ChangelogState>((set) => ({
  isModalOpen: false,
  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false }),
}));
